import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EmailForm = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    navigate(`/contact?email=${encodeURIComponent(email)}`);
    setEmail('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group email-form" style={{ position: 'relative' }}>
        <input
          type="email"
          className="form-control"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          className="btn btn-primary email-icon"
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <i className="fa fa-paper-plane" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  );
};

export default EmailForm;
